export default __webpack_public_path__ + "static/media/Twitter.28958390.svg";